import React, { useEffect, useState } from 'react';
import { Backdrop, CircularProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useLocation, useNavigate } from 'react-router';
import LeftArrow from '../../../asset/svg/leftArrow.svg';
import { EMPLOYEE_HELPDESK_PATH, EMPLOYEE_HELPDESK_VIEW_IMAGES } from '../../../utils/Constants';
import '../../../scss/pages/Employee helpdesk/EmployeeHelpDeskComments/employeeHelpdeskComments.scss';
import TagOpenReq from '../../../asset/svg/TagOpenReq.svg';
import Chat from '../../../asset/svg/Chat.svg';
import EllipseDot from '../../../asset/svg/EllipseDot.svg';
import Calendar from '../../../asset/svg/Calendar-Icon.svg'
import HelpDeskChatBox from '../HelpDeskChatbox/HelpDeskChatBox';
import { useDispatch, useSelector } from 'react-redux';
import { POST_GET_EMP_TICKET } from '../../../sagas/type';
import { getLocalStoreString } from '../../../utils/Helper';
import { generateNumRandomId } from '../../../components/common/GenerateRandomId/GenerateRandomId';
import pdfFIleIcon from '../../../asset/svg/pdfFile.svg'
import moment from 'moment';

function EmployeeHelpdeskComments() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { GetEmpTicket } = useSelector(mapStateToProps);
    const [loader, setLoader] = useState(true);
    const location = useLocation();

    useEffect(() => {
        if (GetEmpTicket) {
            setLoader(false)
        }
    }, [])

    useEffect(() => {
        const EmployeeID = getLocalStoreString('EmployeeId');
        const TenantId = getLocalStoreString("CompanyID");
        const traceId = generateNumRandomId(8);
        const getTicketReq = {
            traceId: traceId,
            employeeId: EmployeeID,
            companyId: TenantId,
            ticketNo: location?.state?.ticketNo,
        }
        dispatch({
            type: POST_GET_EMP_TICKET,
            payload: getTicketReq,
        })
    }, [])

    const handleBack = () => {
        navigate(EMPLOYEE_HELPDESK_PATH)
    }

    const handleShowImage = (image) => {
        const arrFiles = []
        arrFiles.push(image)
        if (arrFiles.length > 0) {
            navigate(EMPLOYEE_HELPDESK_VIEW_IMAGES, { state: { pdf: image, images: arrFiles } })
        }
    }

    const renderUploadedFile = (fileObj, index) => {
        console.log(fileObj)
        if (fileObj?.attachmentUrl !== '' && fileObj?.attachmentType !== '') {
            if (fileObj?.attachmentType === "application/pdf") {
                return (
                    <div key={index} style={{ borderRadius: "8px", width: "70px", height: "79px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: 'rgba(24, 39, 79, 1)', border: "0.25px solid rgba(255, 255, 255, 0.09)" }}>
                        <img src={pdfFIleIcon} alt='' style={{ backgroundColor: 'rgba(255, 255, 255, 0.09)' }} />
                    </div>
                )
            } else {
                return (
                    <div key={index} style={{ width: "70px", height: "79px", borderRadius: "8px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <img src={fileObj?.attachmentUrl} alt='' style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "8px" }} />
                    </div>
                );
            }
        }
    }

    return (
        <>
            <div className='Employee-Helpdesk-comments-Container'>
                <div className='Employee-Helpdesk-comments-Container_header'>
                    <div className='Employee-Helpdesk-comments-Container_header_head-height'>
                        <img className='Employee-Helpdesk-comments-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                        <span className='Employee-Helpdesk-comments-Container_header_head-height_content'>Service Desk</span>
                    </div>
                </div>
                <div className='Employee-Helpdesk-comments-Container_Card-Head'>
                    <Box sx={{ marginTop: "5px" }} >
                        <Box className='Employee-Helpdesk-comments-Container_Card-Head_Data'>
                            <div className='Employee-Helpdesk-comments-Container_Card-Head_Data_Child'>
                                <div className='Employee-Helpdesk-comments-Container_Card-Head_Data_Child_Child-sub'>
                                    <div className='Employee-Helpdesk-comments-Container_Card-Head_Data_Child_Child-sub_Icon-tag'>
                                        <img src={TagOpenReq} width='20px' height='20px' />
                                        <Typography sx={{ fontSize: "10px", fontWeight: 500, fontFamily: "'Noto Sans', sans-serif", color: "rgba(255, 255, 255, 0.40)" }}>{GetEmpTicket?.ticketNo}</Typography>
                                    </div>
                                    {GetEmpTicket.status == 'NEW' && <div className='Employee-Helpdesk-comments-Container_Card-Head_Data_Child_Child-sub_New-sts'>
                                        <Typography sx={{ color: "#EAA439", fontSize: "10px", fontWeight: 500, fontFamily: "'Noto Sans', sans-serif" }}>New</Typography>
                                    </div>}
                                    {GetEmpTicket.status == 'INPROGRESS' && <div className='Employee-Helpdesk-comments-Container_Card-Head_Data_Child_Child-sub_Inprogress-sts'>
                                        <Typography sx={{ color: "#12B9DD", fontSize: "10px", fontWeight: 500, fontFamily: "'Noto Sans', sans-serif" }}>In Progress</Typography>
                                    </div>}
                                    {GetEmpTicket.status == 'CLOSED' && <div className='Employee-Helpdesk-comments-Container_Card-Head_Data_Child_Child-sub_Closed-sts'>
                                        <Typography sx={{ color: "#6FDF97", fontSize: "10px", fontWeight: 500, fontFamily: "'Noto Sans', sans-serif" }}>Resolved</Typography>
                                    </div>}
                                </div>
                                <div className='Employee-Helpdesk-comments-Container_Card-Head_Data_Child_Child-sub2'>
                                    <div className='Employee-Helpdesk-comments-Container_Card-Head_Data_Child_Child-sub2_Category'>
                                        <Typography sx={{ color: "#FFF", fontSize: "14px", fontWeight: 600, fontFamily: "'Noto Sans', sans-serif", whiteSpace: "nowrap" }}>{GetEmpTicket?.subCategoryVo?.name}</Typography>
                                        <img src={EllipseDot} width='7px' height='7px' />
                                        <Typography sx={{ color: "rgba(255, 255, 255, 0.40)", fontSize: "12px", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif", whiteSpace: "nowrap" }}>{GetEmpTicket?.subCategoryVo?.category}</Typography>
                                    </div>
                                    <Typography sx={{ color: "rgba(255, 255, 255, 0.70)", fontSize: "12px", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif", whiteSpace: "nowrap" }}>{GetEmpTicket?.description}</Typography>
                                    <div className='Employee-Helpdesk-comments-Container_Card-Head_Data_Child_Child-sub2_Date-Icon'>
                                        <img src={Calendar} width='10px' height='10px' />
                                        <Typography sx={{ color: "#FFF", fontSize: "10px", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif", whiteSpace: "nowrap", opacity: 0.4 }}>{moment(GetEmpTicket?.createdDate).format("DD MMM YYYY, HH:mm")}</Typography>
                                    </div>
                                </div>
                                <div className='Employee-Helpdesk-comments-Container_Card-Head_Data_Child-Image'>
                                    {GetEmpTicket?.attachments?.length > 0 && GetEmpTicket?.attachments?.map((image) => {
                                        return (
                                            <div key={image.id} onClick={() => handleShowImage(image)}>
                                                {renderUploadedFile(image, image.id)}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </Box>
                    </Box>
                </div>
                {GetEmpTicket.status == 'CLOSED' && GetEmpTicket?.modifiedEmployeeName && GetEmpTicket?.updatedDate && <div className='Employee-Helpdesk-comments-Container_Marked-content'>
                    <Typography sx={{ color: "rgba(255, 255, 255, 0.70)", fontSize: "9px", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif", fontStyle: "italic", textAlign: "center" }}>{GetEmpTicket?.modifiedEmployeeName} marked issue as resolved on {moment(GetEmpTicket?.updatedDate).format("DD MMM YYYY, HH:mm")}</Typography>
                </div>}
                <div className='Employee-Helpdesk-comments-Container_Comments-text'>
                    <Typography sx={{ color: "#fff", fontSize: "14px", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif" }}>Comments</Typography>
                </div>
                <div className='Employee-Helpdesk-comments-Container_Chatbox'>
                    <HelpDeskChatBox GetEmpTicket={GetEmpTicket} />
                </div>
            </div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        GetEmpTicket: state?.employeeHelpdesk?.GetEmpTicket,
        TicketData: state?.employeeHelpdesk?.TicketData
    }
}

export default EmployeeHelpdeskComments